module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO FROM")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KASHI")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LASSICS")]), _vm._v(": R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEGADE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPRINT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Home: Social Essays")])]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_vm._v("by LeRoi Jones (Amiri Baraka)")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Hungered One")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("short stories by Ed Bullins")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23451398","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c7.vue
// module id = 75
// module chunks = 0